import FunctionTimer from "../utilities/FunctionTimer";

class FeaturedMedia extends HTMLElement {
  constructor() {
    super();

    // Set arrays to iterate over and search through.
    this.pictures = Array.from(this.children);
    this.buttons = Array.from(document.querySelectorAll('#hero .call-to-actions .btn'));

    // Config
    this.currentIndex = 0;
    this.hover = false;
  }

  connectedCallback() {
    // Check if not homepage.
    if (this.pictures.length < 1) return;

    // If homepage.
    if (this.pictures.length > 1 && this.buttons !== undefined) {

      const currentElements = this.GetElementsByIndex(this.currentIndex);

      // Set currently active elements.
      this.currentButton = currentElements.button;
      this.currentPicture = currentElements.picture;

      this.buttonSwitcher = new FunctionTimer(() => {
        this.currentIndex = (this.currentIndex + 1) % this.buttons.length;
        const nextElements = this.GetElementsByIndex(this.currentIndex);

        this.currentButton.classList.add('btn-inverted');
        this.currentPicture.classList.remove('active');

        nextElements.button.classList.remove('btn-inverted');
        nextElements.picture.classList.add('active');

        this.currentButton = nextElements.button;
        this.currentPicture = nextElements.picture;
      }, 4000);


      /* For each button in the hero, add two event listeners, 
       * mouseenter and mouseleave to simulate a 'hover' effect.
       */
      this.buttons.forEach((button) => {

        button.addEventListener('mouseenter', (e) => {

          this.hover = true;
          this.buttonSwitcher.Stop();

          this.currentButton.classList.add('btn-inverted');
          e.target.classList.remove('btn-inverted');

          const activePicture = this.pictures.find((picture) => picture.dataset.fmedia === button.dataset.fmedia);
          this.currentPicture.classList.remove('active');
          activePicture.classList.add('active');

        });

        button.addEventListener('mouseleave', (e) => {

          // If user is hovering on current button, this should not change on mouseleave.
          if (e.target !== this.currentButton) {
            e.target.classList.add('btn-inverted');

            const activePicture = this.pictures.find((picture) => picture.dataset.fmedia === e.target.dataset.fmedia);
            activePicture.classList.remove('active');
          }

          this.hover = false;
          this.buttonSwitcher.Start();

          // Only return to the currently active elements if the user is not hovering.
          setTimeout(() => {
            if (!this.hover) {
              this.currentButton.classList.remove('btn-inverted');
              this.currentPicture.classList.add('active');
            }
          }, 300)

        });

      });


      this.buttonSwitcher.Start();
    }
  }

  GetElementsByIndex(index) {
    return {
      button: this.buttons.find((button) => button.dataset.fmedia == index),
      picture: this.pictures.find((picture) => picture.dataset.fmedia == index)
    }
  }
}

customElements.define('featured-media', FeaturedMedia);